import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a945c2c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("div", null, "操作提示："),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px","font-size":"14px"} }, "平台审核商家发布的商品，当商品审核通过并且处于销售中状态时，商家可以销售该商品"),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px","font-size":"14px"} }, "平台可通过“违规重审”，下架违规商品并标记为审核未通过。")
], -1))
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"margin-left":"60px","position":"absolute"} }
const _hoisted_4 = {
  class: "name",
  style: {"margin-top":"-30px"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("商品名称：")
const _hoisted_6 = { style: {"margin-top":"15px"} }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("时间段：")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("售价：")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("秒杀价：")
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("违规重审")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "秒杀商品" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.searches.type,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.type) = $event)),
          onChange: _ctx.onchange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeData, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: item.name,
                tab: item.title + ' (' +item.count +')' 
              }, null, 8, ["tab"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["activeKey", "onChange"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: _ctx.columns,
          loading: _ctx.loading,
          bordered: "",
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'goods')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("img", {
                    src: record.image,
                    style: {"width":"50px","height":"50px","margin-top":"-25px","position":"absolute"}
                  }, null, 8, _hoisted_2),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("span", null, _toDisplayString(record.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.cate_name_address, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", { key: index }, [
                          (index>10)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, " > "))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(item), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'sale')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _hoisted_9,
                    _createElementVNode("span", null, _toDisplayString(record.time), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_10,
                    _createElementVNode("span", null, _toDisplayString(record.goods_price), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_11,
                    _createElementVNode("span", null, _toDisplayString(record.seckill_price), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (column.key === 'update_time')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", null, _toDisplayString(record.date), 1)
                ]))
              : _createCommentVNode("", true),
            (column.key === 'tags')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(record.review_status_desc), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin-left":"10px"},
                    onClick: ($event: any) => (_ctx.goodsReAudit(record,1))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (record.review_status == 1)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        style: {"margin-left":"10px"},
                        onClick: ($event: any) => (_ctx.goodsReAudit(record,2))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: _ctx.title,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
      onOk: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleOk(1))),
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleOk(2))),
      "ok-text": "通过",
      "cancel-text": "不通过"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_textarea, {
          value: _ctx.reason,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reason) = $event)),
          placeholder: "请输入审核意见",
          "auto-size": { minRows: 4, maxRows: 4 }
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["title", "visible"])
  ]))
}